import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  postCategoryManage,
  deleleteCategory,
} from "../../../store/Action/categoryAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
function ManageCategory() {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [deletes, setDelete] = useState(1);
  const itemsPerPage = 10; // Change this to the desired number of items per page
  const role = localStorage.getItem("role");
  // console.log(role, "role");

  // Logic to calculate total pages
  const queryParams = { page: currentPage, perPage: itemsPerPage };

  // Fetch categories and total count from API or any data source
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await dispatch(postCategoryManage(queryParams));
        if (response) {
          setCategories(response.data.category); // Update with the correct field name from your API response
          // setTotalCount(response.data.totalCount);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [dispatch, currentPage, deletes]);

  // Logic to handle pagination controls
  const nextPage = () => {
    if (categories.length === itemsPerPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleDelete = (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      const response = dispatch(deleleteCategory(categoryId));
      if (response) {
        setDelete(response);
      }
    }
  };
  return (
    <div className="manage-category">
      <div className="card">
        <div className="card-header">Manage Category</div>
        <div className="card-body">
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Category Order</th>
                <th scope="col">Category Name</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr key={category._id}>
                  <td>{category.categoryOrder}</td>
                  <td>{category.displayName}</td>
                  <td>{category.status == 1 ? "Active" : "Inactive"}</td>
                  <td>
                    <Link to={`/editcategory/${category._id}`}>
                      <button
                        className="action-button"
                        //  onClick={() => handleEdit(category)}
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </Link>

                    {/* {role === "superadmin" && (
                      <button
                        className="action-button"
                        onClick={() => handleDelete(category._id)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )} */}
                  </td>
                  {/* Add action buttons here */}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="card-footer bg-transparent border-secondary d-flex justify-content-center">
            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="current-page">{currentPage}</span>

              <button
                className="pagination-btn"
                onClick={nextPage}
                disabled={categories.length < itemsPerPage}
              >
                {categories.length < itemsPerPage ? "" : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageCategory;
